import React, { memo } from 'react';
import styled from 'styled-components';

type ProgressBarProps = {
	rate: number; // 진행률 (0 ~ 100)
	width?: number; // 트랙 너비(px), 미지정 시 100%
};

// 진행률 게이지 바 (파란색 채움 + 회색 트랙)
const ProgressBar = memo<ProgressBarProps>(({ rate, width }) => {
	const clampedRate = Math.min(100, Math.max(0, rate));

	return (
		<Track $width={width}>
			<Fill $rate={clampedRate} />
		</Track>
	);
});

ProgressBar.displayName = 'ProgressBar';

export default ProgressBar;

const Track = styled.div<{ $width?: number }>`
	width: ${({ $width }) => ($width ? `${$width}px` : '100%')};
	height: 6px;
	border-radius: 3px;
	background-color: ${({ theme }) => theme.colors.ultraLightGrayBorder};
	overflow: hidden;
`;
const Fill = styled.div<{ $rate: number }>`
	width: ${({ $rate }) => $rate}%;
	height: 100%;
	border-radius: 3px;
	background-color: ${({ theme }) => theme.colors.activeBlue};
	transition: width 0.25s ease-in-out;
`;
